import React from 'react';
import {
  Router as BaseRouter,
  Switch,
  Route
} from 'react-router-dom';
import history from './history';

import ViziaPlatform from './containers/ViziaPlatform';
import Deck from './containers/Deck';
import Invite from './containers/Invite';
import Homescreen from './components/Homescreen.jsx';
import PrivateLinkEntrypoint from './components/PrivateLinkEntrypoint.jsx';
import Screen from './containers/Screen.js';

class Router extends React.Component {
  render() {
    return (
      <BaseRouter history={history}>
        <ViziaPlatform>
          <Switch>
            <Route exact path="/i" component={Homescreen} />
            <Route path="/i/:inviteId" component={Invite} />
            <Route path="/in/:inviteId" component={Invite} />
            <Route path="/p/:deckHash" component={Deck} />
            <Route path="/channel/f/:folderId" component={Screen} />
            <Route path="/pl/:privateLinkIdHash" component={PrivateLinkEntrypoint} />
          </Switch>
        </ViziaPlatform>
      </BaseRouter>
    );
  }
}

export default Router;
